import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {UserTrace} from "@commons/types";
import {Calc} from "@commons/mapping/Calc";

export interface ArrotondamentiRangeRecord extends URIAndTrace {
    idAziendaTabelle: number;
    idArrotondamenti: number;
    insertTrace: UserTrace;
    finoA: string; // string hhmm
    ent: string; // string hhmm
    usc: string; // string hhmm
}

export class ArrotondamentiRangeRecord {
    static getFinoA = function (that: ArrotondamentiRangeRecord, offset: number = 0) {
        if (offset === 0) {
            return parseInt(that.finoA);
        }
        return Calc.hhcc2hhmm(Calc.hhmm2hhcc(parseInt(that.finoA)) + Calc.hhmm2hhcc(offset));
    };

    static getEntrata = function (that: ArrotondamentiRangeRecord, offset: number = 0) {
        if (offset === 0) {
            return parseInt(that.ent);
        }
        return Calc.hhcc2hhmm(Calc.hhmm2hhcc(parseInt(that.ent)) + Calc.hhmm2hhcc(offset));
    };

    static getUscita = function (that: ArrotondamentiRangeRecord, offset: number = 0) {
        if (offset === 0) {
            return parseInt(that.usc);
        }
        return Calc.hhcc2hhmm(Calc.hhmm2hhcc(parseInt(that.usc)) + Calc.hhmm2hhcc(offset));
    };
}